import React, { Component } from 'react'
import Loading from './Loading'
import PropTypes from 'prop-types'
import InputRow from './InputRow'
export default class EducationHistoryGraduate extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      error: '',
      graduateDegree: [],
      universityCertificate: '',
      universityCertificateData: [],
      yearOfGraduation: '',
      universityName: 0,
      selectedCountry: '',
      gpa: '',
      universityNameData: [],
      countryData: this.props.countryData,
      institutionName: ''
    }
    this.addGraduateDegree = this.addGraduateDegree.bind(this)
  }

  componentDidMount () {
    fetch(`${process.env.REACT_APP_API_URL}/api/EducationHistory/GetUniversityCurriculum`)
      .then(res => res.json())
      .then(res => {
        this.setState({ universityCertificateData: res, universityCertificate: '' })
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}/api/EducationHistory/GetUniversitiesName`))
      .then(res => res.json())
      .then(res => {
        console.log(this.props)
        this.setState({ universityNameData: res, universityName: '' })
        if (this.props.educationHistory.length > 1) {
          const graduateDegree = []
          this.props.educationHistory.forEach((element, index) => {
            let universityName/*  = res.filter(ele => ele.value === element.InstitutionName) */
            if (element.InstitutionId === 'other') {
              universityName = [{ Id: 'other', value: element.InstitutionName }]
            } else {
              universityName = res.filter(ele => ele.Id === parseInt(element.InstitutionId))
            }
            let endDate = ''
            if (element.EndDate) {
              const date = new Date(element.EndDate)
              let month = date.getMonth() + 1
              let day = date.getDate()
              let year = date.getFullYear()
              if (month < 10) {
                month = '0' + month
              }
              if (day < 10) {
                day = '0' + day
              }
              if (year < 10) {
                year = '000' + year
              } else if (year < 100) {
                year = '00' + year
              } else if (year < 1000) {
                year = '0' + year
              }
              endDate = year + '-' + month + '-' + day
            }
            this.setState({ dateOfBirth: endDate })
            if (index <= this.props.educationHistory.length - 2) {
              graduateDegree.push({
                universityCertificate: element.CurriculumId,
                yearOfGraduation: endDate,
                universityName: universityName && universityName.length > 0 ? universityName[0].Id : '',
                selectedCountry: element.CountryId,
                gpa: element.GPA,
                institutionName: element.InstitutionName
              })
            } else {
              this.setState({
                universityCertificate: element.CurriculumId,
                yearOfGraduation: endDate,
                universityName: universityName && universityName.length > 0 ? universityName[0].Id : '',
                selectedCountry: element.CountryId,
                gpa: element.GPA,
                institutionName: element.InstitutionName
              })
            }
          })
          this.setState({ graduateDegree: graduateDegree, loading: false })
        } else if (this.props.educationHistory.length === 1) {
          const element = this.props.educationHistory[0]
          let endDate = ''
          if (element.EndDate) {
            const date = new Date(element.EndDate)
            let month = date.getMonth() + 1
            let day = date.getDate()
            let year = date.getFullYear()
            if (month < 10) {
              month = '0' + month
            }
            if (day < 10) {
              day = '0' + day
            }
            if (year < 10) {
              year = '000' + year
            } else if (year < 100) {
              year = '00' + year
            } else if (year < 1000) {
              year = '0' + year
            }
            endDate = year + '-' + month + '-' + day
          }
          let universityName/*  = res.filter(ele => ele.value === element.InstitutionName) */
          if (element.InstitutionId === 'other') {
            universityName = [{ Id: 'other', value: element.InstitutionName }]
          } else {
            universityName = res.filter(ele => ele.Id === parseInt(element.InstitutionId))
          }
          this.setState({
            universityCertificate: element.CurriculumId,
            yearOfGraduation: endDate,
            universityName: universityName && universityName.length > 0 ? universityName[0].Id : '',
            selectedCountry: element.CountryId,
            gpa: element.GPA,
            institutionName: element.InstitutionName,
            loading: false
          })
        } else {
          this.setState({ loading: false })
        }
      })
      .catch(err => console.log(err))
  }

  removeGraduateDegree (index) {
    const { graduateDegree, universityCertificate, yearOfGraduation, universityName, gpa, selectedCountry, institutionName } = this.state
    const degrees = []
    graduateDegree.forEach((element, index1) => {
      if (index1 !== index) {
        degrees.push(element)
      }
    })
    this.props.collectState('EH', {
      graduateDegree: degrees,
      universityCertificate: universityCertificate,
      yearOfGraduation: yearOfGraduation,
      universityName: universityName,
      selectedCountry: selectedCountry,
      gpa: gpa,
      institutionName: institutionName

    })
    this.setState({ graduateDegree: degrees })
  }

  addGraduateDegree () {
    const { universityCertificate, yearOfGraduation, universityName, gpa, selectedCountry, institutionName } = this.state
    if (universityCertificate !== '' && yearOfGraduation && universityName !== '' && selectedCountry !== '' && gpa) {
      if (universityName === 'other' && !institutionName) {
        alert('Please fill all required fields before adding new!')
      } else {
        const degree = {
          universityCertificate: universityCertificate,
          yearOfGraduation: yearOfGraduation,
          universityName: universityName,
          selectedCountry: this.props.countryData[0].Id,
          gpa: gpa,
          institutionName: institutionName
        }
        this.props.collectState('EH', {
          graduateDegree: [...this.state.graduateDegree, degree],
          universityCertificate: '',
          yearOfGraduation: '',
          universityName: '',
          selectedCountry: '',
          gpa: '',
          institutionName: ''

        })
        this.setState({ graduateDegree: [...this.state.graduateDegree, degree] })
        this.setState({
          universityCertificate: '',
          yearOfGraduation: '',
          universityName: '',
          selectedCountry: '',
          gpa: '',
          institutionName: ''
        })
      }
    } else {
      alert('Please fill all required fields before adding new!')
    }
  }

  renderGraduate () {
    const validationError = this.props.error
    const { loading, graduateDegree, universityNameData, universityCertificateData, universityName, universityCertificate, yearOfGraduation, gpa, selectedCountry, institutionName } = this.state
    if (loading) {
      return <Loading />
    }
    const visibleDetailDegree = []
    if (graduateDegree.length > 0) {
      graduateDegree.forEach((element, index) => {
        let universityName
        if (element.universityName === 'other') {
          universityName = [{ Id: 'other', value: element.institutionName }]
        } else {
          universityName = universityNameData.filter(ele => ele.Id === element.universityName)
        }
        const universityCertificate = universityCertificateData.filter(ele => ele.Id === element.universityCertificate)
        visibleDetailDegree.push(
          <div className="degree-wrapper" key={index}>
            <div>
              <p>{universityName.length > 0 ? universityName[0].value : ''}</p>
              <p>{universityCertificate.length > 0 ? universityCertificate[0].value : ''}</p>
            </div>
            <button onClick={this.removeGraduateDegree.bind(this, index)}>x</button>

          </div>
        )
      })
    }
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>

        <div>
          <div >
            <InputRow
              name="select"
              required="*"
              errMsg={validationError.universityCertificate ? validationError.universityCertificate : ''}
              hover="Please choose the university certificate you earned.يرجى اختيار شهادة الجامعة التي حصلت عليها."
              data={universityCertificateData/*  || [{ Id: 98, value: 'Aneree' }] */}
              rowName="University Certificate"
              value={universityCertificate}
              onChange={(val) => {
                this.setState({ universityCertificate: parseInt(val) })
                this.props.collectState('EH', {
                  graduateDegree: graduateDegree,
                  universityCertificate: val,
                  yearOfGraduation: yearOfGraduation,
                  universityName: universityName,
                  selectedCountry: selectedCountry,
                  gpa: gpa,
                  institutionName: institutionName
                })
              }}
            />
            <InputRow
              name="date"
              required="*"
              errMsg={validationError.yearOfGraduation ? validationError.yearOfGraduation : ''}
              hover="What year did you graduate university? If you can't remember the exact date just put the 1st. في أي عام تخرجت من الجامعة؟ إذا كنت لا تستطيع تذكر التاريخ الدقيق فقط ضع 1."
              value={yearOfGraduation}
              rowName="Year of Graduation"
              onChange={(val) => {
                const dob = new Date(val)
                if (!isNaN(dob.getFullYear())) {
                  if (parseInt(dob.getFullYear()) <= 9999 )   {
                    this.setState({ yearOfGraduation: val })
                    this.props.collectState('EH', {
                      graduateDegree: graduateDegree,
                      universityCertificate: universityCertificate,
                      yearOfGraduation: val,
                      universityName: universityName,
                      selectedCountry: selectedCountry,
                      gpa: gpa,
                      institutionName: institutionName
                    })
                  }
                } else {
                  this.setState({ yearOfGraduation: '' })
                  this.props.collectState('EH', {
                    graduateDegree: graduateDegree,
                    universityCertificate: universityCertificate,
                    yearOfGraduation: '',
                    universityName: universityName,
                    selectedCountry: selectedCountry,
                    gpa: gpa,
                    institutionName: institutionName
                  })
                }
              }}
            />
            <InputRow
              name="select"
              required="*"
              errMsg={validationError.universityName ? validationError.universityName : ''}
              data={universityNameData.length > 0 ? [...universityNameData, { Id: 'other', value: 'Other' }] : universityNameData}
              value={universityName}
              onChange={(val) => {
                if (val === 'other') {
                  this.props.collectState('EH', {
                    graduateDegree: graduateDegree,
                    universityCertificate: universityCertificate,
                    yearOfGraduation: yearOfGraduation,
                    universityName: val,
                    selectedCountry: selectedCountry,
                    gpa: gpa,
                    institutionName: ''
                  })
                  this.setState({ universityName: val, institutionName: '' })
                } else {
                  const institutionNames = universityNameData.filter(ele => ele.Id === parseInt(val))
                  this.props.collectState('EH', {
                    graduateDegree: graduateDegree,
                    universityCertificate: universityCertificate,
                    yearOfGraduation: yearOfGraduation,
                    universityName: val,
                    selectedCountry: selectedCountry,
                    gpa: gpa,
                    institutionName: institutionNames && institutionNames.length > 0 ? institutionNames[0].value : ''
                  })
                  this.setState({ universityName: parseInt(val), institutionName: institutionNames && institutionNames.length > 0 ? institutionNames[0].value : '' })
                }
              }}
              rowName="University Name"
              hover="Insert your Undergraduate name. أدخل اسمك الجامعي"
            />
            {universityName === 'other'
              ? <InputRow
                name="text"
                value={institutionName}
                required="*"
                errMsg={validationError.institutionName ? validationError.institutionName : ''}
                rowName="Name of University"
                onChange={(val) => {
                  this.setState({ institutionName: val })
                  this.props.collectState('EH', {
                    graduateDegree: graduateDegree,
                    universityCertificate: universityCertificate,
                    yearOfGraduation: yearOfGraduation,
                    universityName: universityName,
                    selectedCountry: selectedCountry,
                    gpa: gpa,
                    institutionName: val
                  })
                }}
              /> : null}
            <InputRow
              name="select"
              data={this.props.countryData}
              value={selectedCountry}
              required="*"
              errMsg={validationError.selectedCountry ? validationError.selectedCountry : ''}
              rowName="Country"
              onChange={(val) => {
                this.setState({ selectedCountry: val })
                this.props.collectState('EH', {
                  graduateDegree: graduateDegree,
                  universityCertificate: universityCertificate,
                  yearOfGraduation: yearOfGraduation,
                  universityName: universityName,
                  selectedCountry: val,
                  gpa: gpa,
                  institutionName: institutionName
                })
              }}
            />
            <InputRow
              name="text"
              required="*"
              errMsg={validationError.gpa ? validationError.gpa : ''}
              rowName="GPA"
              value={gpa}
              onChange={(val) => {
                this.setState({ gpa: val })
                this.props.collectState('EH', {
                  graduateDegree: graduateDegree,
                  universityCertificate: universityCertificate,
                  yearOfGraduation: yearOfGraduation,
                  universityName: universityName,
                  selectedCountry: selectedCountry,
                  gpa: val,
                  institutionName: institutionName
                })
              }}
            />
          </div>
        </div>

      </div >
    )
  }

  render () {
    const { loading, error } = this.state
    if (loading) {
      return (<Loading />)
    }

    return (
      <div>
        <p style={{ color: 'red' }}>{error}</p>
        {this.renderGraduate()}
        <button className="save" onClick={() => { this.props.onSave() }}>Next</button>
      </div>
    )
  }
}
EducationHistoryGraduate.propTypes = {
  countryData: PropTypes.array.isRequired,
  program: PropTypes.number.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  educationHistory: PropTypes.array,
  collectState: PropTypes.func,
  error: PropTypes.object
}
